export default __webpack_public_path__ + "static/media/hero-success.288c2122.svg";